module.exports = __webpack_public_path__ + "img/capacity.58b62fa0.svg";